module.exports = __webpack_public_path__ + "img/lit_carnuniswap.2f9d204f.png";